import { AnalyticsEvent } from '../../../../analytics/events/analytics.event'

export class ModalImageEvent extends AnalyticsEvent {
  constructor (eventCategory: string = '', eventAction: string = '', expand: boolean) {
    super('click', eventCategory, eventAction, expand ? 'expand' : 'collapse')
  }
}
